<div class="bars-container">
  <app-horizonal-bar
    class="bar"
    [title]="dictionaryService.get('AvailableLeavesBalance')"
    [available]="leaveBalance.availableAnnual"
    [total]="leaveBalance.totalAllowedAnnual"
    [shifted]="leaveBalance.shiftedAnnual"
  />

  <app-horizonal-bar
    class="bar"
    [title]="dictionaryService.get('EmergencyLeavesBalance')"
    [available]="leaveBalance.availableCasual"
    [total]="leaveBalance.totalAllowedCasual"
    [shifted]="leaveBalance.shiftedCasual"
  />
</div>
